import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $isTableCellNode } from "@lexical/table";
import {
  $createParagraphNode,
  $createTextNode,
  $getNodeByKey,
  $isTextNode,
  TextNode,
} from "lexical";
import { toPairs } from "lodash-es";
import type { FC } from "react";
import { useEffect } from "react";

export const EnsureTextWithinParagraphPlugin: FC = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerMutationListener(TextNode, (mutatedNodes) => {
      toPairs(mutatedNodes).map(([key, mutation]) => {
        if (mutation === "created") {
          editor.update(() => {
            const node = $getNodeByKey(key);

            if (!node) return;
            if (!$isTextNode(node)) return;

            if (!$isTableCellNode(node.getParent())) return;

            const newParagraphNode = $createParagraphNode();

            newParagraphNode.append($createTextNode(node.getTextContent()));

            node.replace(newParagraphNode);
          });
        }
      });
    });
  }, [editor]);

  return <></>;
};
